import React from 'react';
import { Box, type BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const Root = styled(Box)({
    height: 'calc(100vh - 72px)',
    overflow: 'auto'
});

interface PageWrapperProps extends Omit<BoxProps, 'id'> {
    children?: React.ReactNode;
}

export const PageWrapper = ({ children, ...restProps }: PageWrapperProps) => {
    return (
        <Root id="page-wrapper" {...restProps}>
            {children}
        </Root>
    );
};
